import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedMaterialModule } from "../shared/shared-material.module";
import { SharedModule } from "../shared/shared.module";
import { TablesModule } from "../views/tables/tables.module";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedFeaturesComponentModule } from "./shared/shared-features-component.module";
//ovde se importuju moduli zajednicki svim featurima
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TablesModule,
    NgxMatSelectSearchModule,
    SharedFeaturesComponentModule
  ],
  exports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TablesModule,
    SharedFeaturesComponentModule
  ],
  providers: [
    DatePipe
  ]
})
export class FeaturesModule { }
